module.exports = __webpack_public_path__ + "img/hand.43f04636.svg";